
(function () {
    'use strict';
  
    var YT_API_SRC = 'https://www.youtube.com/iframe_api';
    var VM_API_SRC = 'https://player.vimeo.com/api/player.js';
  
    var _ytState = 'idle';
    var _ytQueue = [];
  
    function onYTReady(cb) {
      if (_ytState === 'ready') { cb(); return; }
      _ytQueue.push(cb);
      if (_ytState !== 'idle') return;
      _ytState = 'loading';
  
      var prevCb = window.onYouTubeIframeAPIReady;
      window.onYouTubeIframeAPIReady = function () {
        if (typeof prevCb === 'function') prevCb();
        _ytState = 'ready';
        var q = _ytQueue.splice(0);
        for (var i = 0; i < q.length; i++) q[i]();
      };
  
      if (!document.querySelector('script[src="' + YT_API_SRC + '"]')) {
        var s = document.createElement('script');
        s.src = YT_API_SRC;
        document.head.appendChild(s);
      }
    }
  
    var _vmState = 'idle';
    var _vmQueue = [];
  
    function onVMReady(cb) {
      if (_vmState === 'ready') { cb(); return; }
      _vmQueue.push(cb);
      if (_vmState !== 'idle') return;
      _vmState = 'loading';
  
      if (!document.querySelector('script[src="' + VM_API_SRC + '"]')) {
        var s = document.createElement('script');
        s.src = VM_API_SRC;
        s.onload = function () {
          _vmState = 'ready';
          var q = _vmQueue.splice(0);
          for (var i = 0; i < q.length; i++) q[i]();
        };
        document.head.appendChild(s);
      }
    }
  
    function parseVideoUrl(url) {
      if (!url || typeof url !== 'string') return null;
      var u = url.trim();
  
      var yt = u.match(
        /(?:youtu\.be\/|youtube\.com\/(?:watch\?(?:.*&)?v=|embed\/|v\/|shorts\/))([A-Za-z0-9_-]{11})/
      );
      if (yt) return { type: 'youtube', id: yt[1] };
  
      var vm = u.match(/(?:vimeo\.com\/(?:video\/)?|player\.vimeo\.com\/video\/)(\d+)/);
      if (vm) return { type: 'vimeo', id: vm[1] };
  
      return null;
    }
  
    function toArray(nodeList) {
      return Array.prototype.slice.call(nodeList);
    }
  
    function SectionController(el) {
      this.el        = el;
      this.sectionId = el.dataset.sectionId;
      this.items     = [];
  
      this.modelGroups = {};
      this.modelOrder  = [];
      this.activeModel = null;
      this.modelIdx    = 0;  
  
      this._ytPlayer  = null;
      this._ytReady   = false;
      this._vmPlayer  = null;
      this._vmReady   = false;
      this._activeType = null;
      this._swiper    = null;
  
      this._d = {};
      this._listeners = [];
  
      this._init();
    }
  
    SectionController.prototype._init = function () {
      var self = this;
      var el   = this.el;
      var d    = this._d;
  
      d.dropdown    = el.querySelector('.pro-reviews__body .pro-reviews__dropdown');
      d.trigger     = el.querySelector('.pro-reviews__body .pro-reviews__dropdown-trigger');
      d.list        = el.querySelector('.pro-reviews__body .pro-reviews__dropdown-list');
      d.infoEls     = toArray(el.querySelectorAll('.pro-reviews__info'));
      d.ytWrap      = el.querySelector('.pro-reviews__yt-wrap');
      d.vmWrap      = el.querySelector('.pro-reviews__vm-wrap');
      d.vmIframe    = el.querySelector('.pro-reviews__vm-iframe');
      d.placeholder = el.querySelector('.pro-reviews__placeholder');
      d.swiperEl    = el.querySelector('.pro-reviews__swiper');
      d.mobileCards = toArray(el.querySelectorAll('.pro-reviews__mobile-card'));
      d.dropItems   = toArray(el.querySelectorAll('.pro-reviews__dropdown-item'));
  
      var raw = (window.__proReviewsData || {})[this.sectionId] || [];
      this.items = raw.map(function (r) {
        return { idx: r.idx, model: r.model, url: r.url, parsed: parseVideoUrl(r.url) };
      });
  
      if (!this.items.length) return;
  
      // Build model groups (preserving appearance order)
      this.items.forEach(function (item) {
        if (!self.modelGroups[item.model]) {
          self.modelGroups[item.model] = [];
          self.modelOrder.push(item.model);
        }
        self.modelGroups[item.model].push(item);
      });
  
      this.activeModel = this.modelOrder[0] || null;
      this.modelIdx    = 0;
  
      this._bindEvents();
      this._updateUI();
  
      var initItem = this._currentItem();
      if (this._isMobile()) {
        this._initSwiper();
        if (initItem) this._setMobileVideo(initItem.idx);
      } else {
        if (initItem) this._loadVideoItem(initItem);
      }
  
      var self2      = this;
      var resizeTimer;
      var lastMobile = this._isMobile();
      this._resizeHandler = function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
          self2._updateUI();
          var nowMobile = self2._isMobile();
          if (nowMobile !== lastMobile) {
            lastMobile = nowMobile;
            var curItem = self2._currentItem();
            if (nowMobile) {
              self2._initSwiper();
              if (curItem) self2._setMobileVideo(curItem.idx);
            } else {
              if (self2._swiper) { self2._swiper.destroy(true, true); self2._swiper = null; }
              if (curItem) self2._loadVideoItem(curItem);
            }
          }
        }, 80);
      };
      window.addEventListener('resize', this._resizeHandler, false);
    };
  
    /* Returns the item object for the current model + modelIdx */
    SectionController.prototype._currentItem = function () {
      var group = this.modelGroups[this.activeModel] || [];
      return group[this.modelIdx] || null;
    };
  
    SectionController.prototype._on = function (target, type, fn) {
      target.addEventListener(type, fn, false);
      this._listeners.push([target, type, fn]);
    };
  
    SectionController.prototype._bindEvents = function () {
      var self = this;
      var el   = this.el;
  
      this._on(el, 'click', function (e) {
        /* ── Nav arrow ── */
        var btn = e.target.closest('.pro-reviews__nav-btn');
        if (btn) {
          if (btn.getAttribute('aria-disabled') === 'true') return;
          var isMobileNav = !!btn.closest('.pro-reviews__nav--mobile');
          if (isMobileNav && self._swiper) {
            if (btn.classList.contains('pro-reviews__nav-btn--prev')) self._swiper.slidePrev(300);
            else if (btn.classList.contains('pro-reviews__nav-btn--next')) self._swiper.slideNext(300);
          } else {
            if (btn.classList.contains('pro-reviews__nav-btn--prev')) self._go(self.modelIdx - 1);
            else if (btn.classList.contains('pro-reviews__nav-btn--next')) self._go(self.modelIdx + 1);
          }
          return;
        }
  
        /* ── Dropdown trigger ── */
        var trigger = e.target.closest('.pro-reviews__dropdown-trigger');
        if (trigger) {
          e.stopPropagation();
          var dd = trigger.closest('.pro-reviews__dropdown');
          if (!dd) return;
          if (dd.getAttribute('aria-expanded') === 'true') {
            self._closeAllDropdowns();
          } else {
            self._closeAllDropdowns();
            self._openDropdownEl(dd);
          }
          return;
        }
  
        /* ── Dropdown item ── */
        var item = e.target.closest('.pro-reviews__dropdown-item');
        if (item) {
          var modelName = item.dataset.prModel;
          if (modelName) self._selectModel(modelName);
          self._closeAllDropdowns();
          return;
        }
      });
  
      this._d.dropItems.forEach(function (item) {
        self._on(item, 'keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            var modelName = item.dataset.prModel;
            if (modelName) self._selectModel(modelName);
            self._closeAllDropdowns();
            return;
          }
          if (e.key === 'ArrowDown') { e.preventDefault(); var n = item.nextElementSibling; if (n) n.focus(); }
          if (e.key === 'ArrowUp')   { e.preventDefault(); var p = item.previousElementSibling; if (p) p.focus(); }
        });
      });
  
      this._on(document, 'click', function (e) {
        if (!el.contains(e.target)) self._closeAllDropdowns();
      });
  
      this._on(document, 'keydown', function (e) {
        if (e.key === 'Escape') self._closeAllDropdowns();
      });
    };
  
    /* Navigate within the current model's video group */
    SectionController.prototype._go = function (withinModelIdx) {
      var group = this.modelGroups[this.activeModel] || [];
      if (withinModelIdx < 0 || withinModelIdx >= group.length) return;
      if (withinModelIdx === this.modelIdx) return;
      this.modelIdx = withinModelIdx;
      this._updateUI();
      var item = this._currentItem();
      if (!item) return;
      if (this._isMobile()) {
        if (this._swiper) this._swiper.slideTo(item.idx, 300, false);
        this._setMobileVideo(item.idx);
      } else {
        this._loadVideoItem(item);
      }
    };
  
    SectionController.prototype._selectModel = function (modelName) {
      if (!this.modelGroups[modelName]) return;
      this.activeModel = modelName;
      this.modelIdx    = 0;
      this._updateUI();
      var item = this._currentItem();
      if (!item) return;
      if (this._isMobile()) {
        if (this._swiper) this._swiper.slideTo(item.idx, 300, false);
        this._setMobileVideo(item.idx);
      } else {
        this._loadVideoItem(item);
      }
    };
  
    SectionController.prototype._isMobile = function () {
      return window.innerWidth <= 768;
    };
  
    SectionController.prototype._updateUI = function () {
      var self     = this;
      var el       = this.el;
      var d        = this._d;
      var group    = this.modelGroups[this.activeModel] || [];
      var i        = this.modelIdx;
      var total    = group.length;
      var item     = this._currentItem();
      var blockIdx = item ? item.idx : 0;
  
      toArray(el.querySelectorAll('.pro-reviews__nav:not(.pro-reviews__nav--mobile) .pro-reviews__nav-cur')).forEach(function (c) {
        c.textContent = String(i + 1);
      });
      toArray(el.querySelectorAll('.pro-reviews__nav:not(.pro-reviews__nav--mobile) .pro-reviews__nav-tot')).forEach(function (c) {
        c.textContent = String(total);
      });

      toArray(el.querySelectorAll('.pro-reviews__nav:not(.pro-reviews__nav--mobile)')).forEach(function (nav) {
        nav.style.display = total <= 1 ? 'none' : '';
      });

      toArray(el.querySelectorAll('.pro-reviews__nav:not(.pro-reviews__nav--mobile) .pro-reviews__nav-btn--prev')).forEach(function (btn) {
        self._setNavState(btn, i === 0);
      });
      toArray(el.querySelectorAll('.pro-reviews__nav:not(.pro-reviews__nav--mobile) .pro-reviews__nav-btn--next')).forEach(function (btn) {
        self._setNavState(btn, i === total - 1);
      });
  
      d.infoEls.forEach(function (panel) {
        var active = parseInt(panel.dataset.prIndex, 10) === blockIdx;
        panel.classList.toggle('pro-reviews__info--active', active);
        panel.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
  
      d.dropItems.forEach(function (dropItem) {
        var active = dropItem.dataset.prModel === self.activeModel;
        dropItem.classList.toggle('pro-reviews__dropdown-item--active', active);
        dropItem.setAttribute('aria-selected', active ? 'true' : 'false');
      });
  
      toArray(el.querySelectorAll('.pro-reviews__dropdown-label')).forEach(function (lbl) {
        lbl.textContent = self.activeModel || '';
      });
    };
  
    SectionController.prototype._setNavState = function (btn, disabled) {
      if (!btn) return;
      btn.setAttribute('aria-disabled', disabled ? 'true' : 'false');
    };

    /* Mobile nav: counter + button states based on overall swiper position */
    SectionController.prototype._updateMobileNav = function () {
      var self       = this;
      var el         = this.el;
      var swiperIdx  = this._swiper ? this._swiper.activeIndex : 0;
      var totalItems = this.items.length;

      toArray(el.querySelectorAll('.pro-reviews__nav--mobile .pro-reviews__nav-cur')).forEach(function (c) {
        c.textContent = String(swiperIdx + 1);
      });
      toArray(el.querySelectorAll('.pro-reviews__nav--mobile .pro-reviews__nav-tot')).forEach(function (c) {
        c.textContent = String(totalItems);
      });
      toArray(el.querySelectorAll('.pro-reviews__nav--mobile .pro-reviews__nav-btn--prev')).forEach(function (btn) {
        self._setNavState(btn, swiperIdx === 0);
      });
      toArray(el.querySelectorAll('.pro-reviews__nav--mobile .pro-reviews__nav-btn--next')).forEach(function (btn) {
        self._setNavState(btn, swiperIdx >= totalItems - 1);
      });
    };
  
    SectionController.prototype._loadVideoItem = function (item) {
      if (!item || !item.parsed) {
        this._showPlaceholder(true);
        return;
      }
      if (item.parsed.type === 'youtube') {
        this._showYT(item.parsed.id);
      } else if (item.parsed.type === 'vimeo') {
        this._showVM(item.parsed.id);
      }
    };
  
    SectionController.prototype._showYT = function (videoId) {
      var self = this;
      var d    = this._d;
  
      if (d.ytWrap) d.ytWrap.style.display = '';
      if (d.vmWrap) d.vmWrap.style.display = 'none';
  
      if (self._vmPlayer && self._vmReady) {
        try { self._vmPlayer.pause(); } catch (ignore) {}
      }
  
      onYTReady(function () {
        if (self._ytPlayer) {
          if (self._ytReady) {
            self._ytPlayer.cueVideoById(videoId);
            self._showPlaceholder(false);
          }
          return;
        }
  
        self._ytPlayer = new YT.Player('pr-yt-' + self.sectionId, {
          width:      640,
          height:     360,
          videoId:    videoId,
          playerVars: { rel: 0, modestbranding: 1, playsinline: 1 },
          events: {
            onReady: function () {
              self._ytReady = true;
              self._showPlaceholder(false);
              var cur = self._currentItem();
              if (cur && cur.parsed && cur.parsed.type === 'youtube') {
                self._ytPlayer.cueVideoById(cur.parsed.id);
              }
            }
          }
        });
      });
    };
  
    SectionController.prototype._showVM = function (videoId) {
      var self = this;
      var d    = this._d;
  
      if (d.vmWrap) d.vmWrap.style.display = '';
      if (d.ytWrap) d.ytWrap.style.display = 'none';
  
      if (self._ytPlayer && self._ytReady) {
        try { self._ytPlayer.pauseVideo(); } catch (ignore) {}
      }
  
      onVMReady(function () {
        if (self._vmPlayer) {
          if (self._vmReady) {
            self._vmPlayer.loadVideo(parseInt(videoId, 10)).catch(function () {});
            self._showPlaceholder(false);
          }
          return;
        }
  
        var vmIframe = d.vmIframe;
        if (!vmIframe) return;
  
        vmIframe.src =
          'https://player.vimeo.com/video/' + videoId +
          '?dnt=1&byline=0&portrait=0&title=0&autopause=0';
  
        self._vmPlayer = new window.Vimeo.Player(vmIframe);
  
        self._vmPlayer.ready().then(function () {
          self._vmReady = true;
          self._showPlaceholder(false);
          var cur = self._currentItem();
          if (cur && cur.parsed && cur.parsed.type === 'vimeo' && cur.parsed.id !== videoId) {
            self._vmPlayer.loadVideo(parseInt(cur.parsed.id, 10)).catch(function () {});
          }
        }).catch(function () {
          self._vmReady = true;
          self._showPlaceholder(false);
        });
      });
    };
  
    SectionController.prototype._showPlaceholder = function (show) {
      var p = this._d.placeholder;
      if (!p) return;
      p.classList.toggle('pro-reviews__placeholder--hidden', !show);
    };
  
    SectionController.prototype._openDropdownEl = function (dd) {
      dd.setAttribute('aria-expanded', 'true');
      var t = dd.querySelector('.pro-reviews__dropdown-trigger');
      if (t) t.setAttribute('aria-expanded', 'true');
      var list = dd.querySelector('.pro-reviews__dropdown-list');
      if (list) list.classList.add('pro-reviews__dropdown-list--open');
    };
  
    SectionController.prototype._closeAllDropdowns = function () {
      toArray(this.el.querySelectorAll('.pro-reviews__dropdown')).forEach(function (dd) {
        dd.setAttribute('aria-expanded', 'false');
        var t = dd.querySelector('.pro-reviews__dropdown-trigger');
        if (t) t.setAttribute('aria-expanded', 'false');
        var list = dd.querySelector('.pro-reviews__dropdown-list');
        if (list) list.classList.remove('pro-reviews__dropdown-list--open');
      });
    };
  
    SectionController.prototype._buildEmbedUrl = function (parsed) {
      if (!parsed) return '';
      if (parsed.type === 'youtube') {
        return 'https://www.youtube.com/embed/' + parsed.id + '?rel=0&modestbranding=1&playsinline=1';
      }
      if (parsed.type === 'vimeo') {
        return 'https://player.vimeo.com/video/' + parsed.id + '?dnt=1&byline=0&portrait=0&title=0&autopause=0';
      }
      return '';
    };
  
    SectionController.prototype._initSwiper = function () {
      var self = this;
      var d    = this._d;
      if (this._swiper || !d.swiperEl) return;
      if (typeof Swiper === 'undefined') return;
  
      var initItem = this._currentItem();
  
      this._swiper = new Swiper(d.swiperEl, {
        slidesPerView: 1.1,
        spaceBetween:  12,
        initialSlide:  initItem ? initItem.idx : 0,
        on: {
          slideChange: function () {
            /* When swiped manually, update model+modelIdx to match the new slide */
            var newSwiperIdx = self._swiper.activeIndex;
            var swipedItem   = self.items[newSwiperIdx];
            if (!swipedItem) return;
            var newModel     = swipedItem.model;
            var group        = self.modelGroups[newModel] || [];
            var newModelIdx  = group.indexOf(swipedItem);
            if (newModel !== self.activeModel || newModelIdx !== self.modelIdx) {
              self.activeModel = newModel;
              self.modelIdx    = newModelIdx;
              self._updateUI();
              self._setMobileVideo(swipedItem.idx);
            }
            self._updateMobileNav();
          }
        }
      });
      self._updateMobileNav();
    };
  
    SectionController.prototype._setMobileVideo = function (blockIdx) {
      var self = this;
      var d    = this._d;
      if (!d.mobileCards || !d.mobileCards.length) return;
      var item     = this.items[blockIdx];
      var embedUrl = item && item.parsed ? self._buildEmbedUrl(item.parsed) : '';
      d.mobileCards.forEach(function (card) {
        var iframe  = card.querySelector('.pro-reviews__mobile-iframe');
        if (!iframe) return;
        var cardIdx = parseInt(card.dataset.prIndex, 10);
        iframe.src  = (cardIdx === blockIdx && embedUrl) ? embedUrl : 'about:blank';
      });
    };
  
    SectionController.prototype.destroy = function () {
      if (this._resizeHandler) {
        window.removeEventListener('resize', this._resizeHandler, false);
        this._resizeHandler = null;
      }
      if (this._swiper) {
        try { this._swiper.destroy(true, true); } catch (e) {}
        this._swiper = null;
      }
      var ls = this._listeners;
      for (var i = 0; i < ls.length; i++) {
        ls[i][0].removeEventListener(ls[i][1], ls[i][2], false);
      }
      this._listeners = [];
  
      if (this._ytPlayer) {
        try { this._ytPlayer.destroy(); } catch (e) {}
        this._ytPlayer = null;
        this._ytReady  = false;
      }
      if (this._vmPlayer) {
        try { this._vmPlayer.destroy(); } catch (e) {}
        this._vmPlayer = null;
        this._vmReady  = false;
      }
    };
    var _registry = {};
  
    function initEl(el) {
      if (el.dataset.prInit) return;
      el.dataset.prInit = '1';
      var id = el.dataset.sectionId;
      _registry[id] = new SectionController(el);
    }
  
    function boot() {
      document.querySelectorAll('.pro-reviews[data-section-id]').forEach(initEl);
    }
  
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
  
    /* Shopify theme editor */
    document.addEventListener('shopify:section:load', function (e) {
      var root = e.target;
      if (!root || !root.querySelector) return;
      var el = root.querySelector('.pro-reviews[data-section-id]');
      if (!el) return;
      delete el.dataset.prInit;
      initEl(el);
    });
  
    document.addEventListener('shopify:section:unload', function (e) {
      var root = e.target;
      if (!root || !root.querySelector) return;
      var el = root.querySelector('.pro-reviews[data-section-id]');
      if (!el) return;
      var id = el.dataset.sectionId;
      if (_registry[id]) {
        _registry[id].destroy();
        delete _registry[id];
      }
    });
  
    /* Jump to correct slide when a block is selected in the editor */
    document.addEventListener('shopify:block:select', function (e) {
      var block = e.target;
      if (!block || !block.closest) return;
      var sectionEl = block.closest('.pro-reviews[data-section-id]');
      if (!sectionEl) return;
      var ctrl = _registry[sectionEl.dataset.sectionId];
      if (!ctrl) return;
      var blockIdx = parseInt((block.dataset || {}).prIndex, 10);
      if (!isNaN(blockIdx)) {
        var targetItem = null;
        for (var j = 0; j < ctrl.items.length; j++) {
          if (ctrl.items[j].idx === blockIdx) { targetItem = ctrl.items[j]; break; }
        }
        if (targetItem) {
          ctrl.activeModel = targetItem.model;
          var grp = ctrl.modelGroups[targetItem.model] || [];
          ctrl.modelIdx = grp.indexOf(targetItem);
          ctrl._updateUI();
          var curItem = ctrl._currentItem();
          if (curItem) ctrl._loadVideoItem(curItem);
        }
      }
    });
  
  })();
  